import SocialLinks from "./SocialLinks";

const SocialLinksContainer = () => {
    return <SocialLinks />
}

export default SocialLinksContainer;